import { API_BASE_URL } from "@/utils/constant";
import { RealEstateCardProps } from "@/components/adsPage/RealEstateCard";
import {DTOAd} from "@/app/(site)/obyavleniya/page";

export async function fetchAdByAlias(alias: string): Promise<RealEstateCardProps | null> {
    // { cache: "force-cache" }
    try {
        const res = await fetch(`${API_BASE_URL}/ads/estate/${alias}` );
        if (!res.ok) return null;
        return await res.json();
    } catch {
        return null;
    }
}
export async function fetchAllActiveAdsDto(){
    const res = await fetch(`${API_BASE_URL}/ads/all?isPublish=true`, { next: { revalidate: 60 } }); // кеширование на 60 сек
    const ads: DTOAd[] = await res.json();
    return ads;
}

export async function fetchIncrementViews(alias: string){
    const res =  await fetch(`${API_BASE_URL}/view/${alias}`);
}

export async function fetchAllAds() {
    try {
        const res = await fetch(`${API_BASE_URL}/ads/estate`, { next: { revalidate: 60 } }); // кеширование на 60 сек
        if (!res.ok) {
            throw new Error(`Ошибка при запросе: ${res.statusText}`);
        }
        const body = await res.text();
        if (!body) {
            throw new Error('Ответ от сервера пустой');
        }
        const ads: RealEstateCardProps[] = JSON.parse(body);
        return ads;
    } catch (error) {
        console.error('Ошибка при получении данных:', error);
        return [];  // Возвращаем пустой массив в случае ошибки
    }
}